module.exports = __webpack_public_path__ + "static/img/list-img0.77b26fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img0.jpg
// module id = eREi
// module chunks = 1